import { FORM_MODE } from '@awp/constants';
import React from 'react';
import { Modal } from 'react-bootstrap';

export type CrudType = CrudView | CrudCreate | CrudEdit | CrudDelete;

export const getCrud = (entityName: string, mode: string, entityPluralName?: string): CrudType | null => {
  let crud = null;

  switch (mode) {
    case FORM_MODE.VIEW:
      crud = new CrudView(entityName);
      break;
    case FORM_MODE.CREATE:
      crud = new CrudCreate(entityName);
      break;
    case FORM_MODE.EDIT:
      crud = new CrudEdit(entityName);
      break;
    case FORM_MODE.DELETE:
      crud = new CrudDelete(entityName);
      break;
    case FORM_MODE.LIST:
      crud = new CrudList(entityName, entityPluralName);
      break;
  }

  return crud;
};

export abstract class Crud {
  mode: string;
  readOnly: boolean;
  entityName: string;
  entityPluralName?: string;
  title?: string;
  relativePath?: string;
  public successMessage?: string;
  public errorMessage?: string;

  protected constructor(entityName: string, mode: string) {
    this.entityName = entityName;
    this.title = entityName;
    this.mode = mode;
    this.readOnly = this.mode === FORM_MODE.VIEW;
  }

  public getHeader(props: any = {}): React.ReactElement {
    const { as, style, className, title, ...rest } = props;
    const Cmp = as ?? 'h1';
    const myTitle = title ? title : this.title;
    return (
      <Cmp style={style} className={className}>
        {myTitle}
      </Cmp>
    );
  }

  public getModalTitle(props: any = {}): React.ReactElement {
    const { as = 'h1', style, className, title, id, ...rest } = props;
    const myTitle = title ? title : this.title;
    return (
      <Modal.Title as={as} style={style} className={className} id={id}>
        {myTitle}
      </Modal.Title>
    );
  }
}

export class CrudDelete extends Crud {
  constructor(entityTitle: string) {
    super(entityTitle, FORM_MODE.DELETE);

    this.title = entityTitle;
    this.successMessage = `Successfully deleted ${entityTitle}`;
    this.errorMessage = `Failed to delete ${entityTitle}`;
  }
}

export class CrudView extends Crud {
  constructor(entityName: string) {
    super(entityName, FORM_MODE.VIEW);

    this.title = entityName;
    this.relativePath = './../../';
  }
}

export class CrudCreate extends Crud {
  public buttonLabel: string;

  constructor(entityName: string) {
    super(entityName, FORM_MODE.CREATE);

    this.title = `Create ${entityName}`;
    this.successMessage = `${entityName} created successfully.`;
    this.errorMessage = `Failed to create ${entityName}.`;
    this.buttonLabel = 'Create';

    this.relativePath = './../';
  }
}

export class CrudEdit extends Crud {
  buttonLabel: string;

  constructor(entityName: string) {
    super(entityName, FORM_MODE.EDIT);

    this.title = `Update ${entityName}`;
    this.successMessage = `${entityName} has been updated`;
    this.errorMessage = `Failed to update ${entityName}.`;
    this.buttonLabel = 'Update';

    this.relativePath = './../../';
  }
}

export class CrudList extends Crud {
  constructor(entityName: string, entityPluralName?: string) {
    super(entityName, FORM_MODE.LIST);

    this.entityPluralName = entityPluralName;
    this.title = entityPluralName ? entityPluralName : entityName;
  }
}
